<app-funnel-shell>
  <div class="funnel-card funnel-result">
    @if (loading()) {
      <p class="funnel-card__intro">{{ 'funnel.result.loading' | translate }}</p>
    }

    @if (resultKey(); as key) {
      <div class="funnel-eyebrow">{{ 'funnel.result.your_recommendation' | translate }}</div>
      <h1>{{ key + '.title' | translate }}</h1>
      <p class="funnel-card__intro">{{ key + '.tagline' | translate }}</p>

      <ul class="funnel-result__features">
        <!--
          Per-card feature lists live in the YAML as `{key}.features` (a list of strings).
          We don't currently iterate them here because Transloco's `translate` pipe
          only handles strings; structured lists need a separate i18n call. For Phase 4
          we hard-code the 4 core features common to every card. Per-card feature lists
          can be added in Phase 5 when we add a TranslocoService call site.
        -->
        <li><img src="/assets/funnel/price.svg" alt="" />{{ key + '.feature_price' | translate: { price: product()?.price } }}</li>
        <!-- The price above is what the checkout charges. A card also carries an
             activation fee paid to the card partner in the card dashboard. -->
        @if (product()?.activation_fee) {
          <li><img src="/assets/funnel/price.svg" alt="" />{{ 'funnel.activation_fee_note' | translate: { fee: '$' + product()?.activation_fee } }}</li>
          <!-- The expiry date printed on the card is read as a term; say here that
               the price is a one-time payment, before the buyer reaches checkout. -->
          <li><img src="/assets/funnel/price.svg" alt="" />{{ 'funnel.one_time_payment_note' | translate: { price: '$' + product()?.total_customer_price } }}</li>
        }
        <li><img src="/assets/funnel/unlimited.svg" alt="" />{{ key + '.feature_limit' | translate }}</li>
        <li><img src="/assets/funnel/contactless.svg" alt="" />{{ 'funnel.result.shared.contactless' | translate }}</li>
        <li><img src="/assets/funnel/headset.svg" alt="" />{{ 'funnel.result.shared.support' | translate }}</li>
        <li><img src="/assets/funnel/protection.svg" alt="" />{{ 'funnel.result.shared.fraud_protection' | translate }}</li>
      </ul>

      <button cButton color="primary" class="w-100 mt-3" (click)="onCheckout()">
        {{ 'funnel.result.buy_now' | translate }}
      </button>

      <div class="funnel-result__password mt-3">
        @if (pwSent() !== null) {
          <div class="alert alert-success" role="alert">
            {{ 'funnel.result.password_sent' | translate: { email: pwSent() } }}
          </div>
        } @else {
          <p class="funnel-card__intro">{{ 'funnel.result.set_password_hint' | translate }}</p>
          <button
            cButton
            color="secondary"
            variant="outline"
            class="w-100"
            [disabled]="pwBusy()"
            (click)="onSetPassword()"
          >
            {{ (pwBusy() ? 'funnel.result.password_sending' : 'funnel.result.set_password_cta') | translate }}
          </button>
          @if (pwError()) {
            <div class="alert alert-danger mt-2" role="alert">
              {{ 'funnel.result.password_error' | translate }}
            </div>
          }
        }
      </div>

      @if (canGoBack()) {
        <button
          type="button"
          class="funnel-result__back"
          [disabled]="busy()"
          (click)="onBackToQuiz()"
        >
          &larr; {{ 'funnel.result.back_to_quiz' | translate }}
        </button>
      }
    }

    @if (error()) {
      <div class="alert alert-danger mt-3" role="alert">{{ error() }}</div>
    }
  </div>
</app-funnel-shell>
